import React, { useState } from "react";
import List from "share/atoms/ListView";
import NavItem from "./nav-item";
import { useHistory } from "react-router-dom";
import { neatRoutes } from "./routes";
import { ListWrap, Overlay } from "./styles";
import { FiMenu } from "react-icons/fi";
import { FaTimes } from "react-icons/fa";
import Logo from "assets/ntat/icons/logo.svg";
import NarayanaLogo from "assets/ntat/icons/narayana-logo.svg"

export default function SidePanel() {
  const history = useHistory();
  const [isExpanded, setIsExpanded] = useState(false);
  const loginType = localStorage.getItem("login-type");

  const navigateToHome = () => {
    history.push("/");
  };

  return (
    <React.Fragment>
      <Overlay isExpanded={isExpanded} />
      <ListWrap
        className={isExpanded && `side-panel-expanded`}
        loginType={loginType}
      >
        <div
          className="hamburger-menu"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <FiMenu color="#3D6AE7"/>
        </div>
        <div className="close-icon" onClick={() => setIsExpanded(!isExpanded)}>
          <FaTimes />
        </div>
        <div className="logo-wrap">
          <img onClick={navigateToHome} src={Logo} alt="cnaps logo" />
          {loginType === "school" && <h3>School</h3>}
        </div>
        <List items={neatRoutes}>
          {(item) => <NavItem key={item.path} route={item} />}
        </List>

        <img src={NarayanaLogo} alt="narayana group logo" className="narayana-logo"/>
      </ListWrap>
    </React.Fragment>
  );
}
